import { agentSettingsPath, websiteLeadsPath } from '@/composables/useAgentSections'
import { CATERING_AGENT_SETTINGS } from '@/services/platformRouting'
import { AGENTS_REQUEST, pickCateringAgent } from '@/view/ai/agentTypes'

const settingsItem = agent => {
  const exact = [CATERING_AGENT_SETTINGS, agentSettingsPath('new')]
  if (!agent) return { name: 'Settings', link: CATERING_AGENT_SETTINGS, exact }
  return { name: 'Settings', link: agentSettingsPath(agent.id), exact: [...exact, agentSettingsPath(agent.id)] }
}

export default {
  bases: [CATERING_AGENT_SETTINGS],
  fetches: [AGENTS_REQUEST],
  build: ({ mapTypeIncludingInactive }) => {
    const agent = pickCateringAgent(mapTypeIncludingInactive('agent'))
    if (!agent) return [settingsItem(null)]
    return [
      settingsItem(agent),
      { name: 'Website leads', link: websiteLeadsPath(agent.id), match: [websiteLeadsPath(agent.id)] }
    ]
  }
}
